import {
  File,
  FileSpreadsheet,
  FileText,
  Presentation,
  type LucideIcon,
} from 'lucide-react';

const BY_PATTERN: Array<[RegExp, LucideIcon]> = [
  [/pdf/, FileText],
  [/word|docx?/, FileText],
  [/excel|spreadsheet|xlsx?|csv/, FileSpreadsheet],
  [/presentation|powerpoint|pptx?/, Presentation],
];

/** Icon for a MIME type or file extension; anything unmatched gets a plain file. */
export function getFileKindIcon(mimeType?: string): LucideIcon {
  if (!mimeType) return File;
  const value = mimeType.toLowerCase();
  return BY_PATTERN.find(([pattern]) => pattern.test(value))?.[1] ?? File;
}
